export class PrescriptionSolutionCheck {
    public idPrescriptionSolutionCheck: number;
    public idUser: number;
    public checkName: boolean;
    public checkMedication: boolean;
    public checkAdministration: boolean;
    public hasPatientDenied: boolean;
    public hasComplaints: boolean;
    public complaints: string;
    public datetimeInclusion: Date;
    public administrationLocal: string;
    public schedulingObservation: string;
    public idPrescriptionSolution: number;
    public idNursingConsultation: number;
    public idStatusScheduling: number;
    public datetimeCheckEstimative: Date;
    public datetimeCheckFulfilled: Date;
    public idUserScheduling: number;   
    public reasonSuspension: string;
}